export default __webpack_public_path__ + "static/media/Subtract.a8343143.svg";